import type { JSX } from 'react'
import type { TextBoxColors } from 'atoms/TextBox'
import type { IListProps } from 'blocks/List'
import type { FIXED_INDENTS } from 'vars/index'

import { List } from 'blocks/List'
import { INDENTS } from 'vars/index'
import { SimpleLabelGroupSC } from './SimpleLabelGroup.styled'

export interface ISimpleLabelGroupProps {
  children: IListProps['children']
  divider?: IListProps['divider']
  width?: IListProps['width']
  direction?: IListProps['direction']
  justifyContent?: IListProps['justifyContent']
  wrap?: IListProps['wrap']
  columnGap?: IListProps['columnGap']
  color?: TextBoxColors
  paddings?: FIXED_INDENTS[]
}

export const SimpleLabelGroup = ({
  children,
  divider,
  width,
  direction,
  justifyContent,
  wrap,
  columnGap = INDENTS.INDENT_10,
  color,
  paddings,
}: ISimpleLabelGroupProps): JSX.Element => (
  <SimpleLabelGroupSC>
    <List
      width={width}
      direction={direction}
      justifyContent={justifyContent}
      wrap={wrap}
      divider={divider}
      columnGap={columnGap}
      color={color}
      paddings={paddings}
    >
      {children}
    </List>
  </SimpleLabelGroupSC>
)
